<template>
    <form ref="form" @submit.prevent="submit" :action="action" method="POST">
        <div>
            <strong>Contact information</strong>
        </div>

        <form-group
            label="Naam"
            name="name"
            :isEditMode="isEditMode"
            :isDisabled="isSubmitting"
            :isValid="!$v.contacts.name.$invalid"
            :contacts="contacts"
        >
            <error-warning v-if="!$v.contacts.name.required">
                Incorrect name. This field is required.
            </error-warning>
        </form-group>

        <form-group
            label="Telefoon"
            name="phone"
            :isEditMode="isEditMode"
            :isDisabled="isSubmitting"
            :isValid="!$v.contacts.phone.$invalid"
            :contacts="contacts"
        >
            <error-warning v-if="!$v.contacts.phone.required">
                Incorrect phone address. This field is required.
            </error-warning>
        </form-group>

        <form-group
            label="E-mailadres"
            name="email"
            :isEditMode="isEditMode"
            :isDisabled="isSubmitting"
            :isValid="!$v.contacts.email.$invalid"
            :contacts="contacts"
        >
            <error-warning v-if="!$v.contacts.email.required">
                Incorrect email address. This field is required.
            </error-warning>

            <error-warning v-if="!$v.contacts.email.email">
                Invalid email address.
            </error-warning>

            <error-warning v-if="this.invalidEmail">
                {{ this.invalidEmail }}
            </error-warning>
        </form-group>

      <form-group
          label="Huidig wachtwoord"
          name="password"
          type="password"
          :isEditMode="isEditMode"
          :isDisabled="isSubmitting"
          :isValid="this.isEmailChanged() && !!this.contacts.password"
          :contacts="contacts"
          v-show="this.isEmailChanged()"
      >
        <error-warning v-if="this.isEmptyPassword">
          Het veld is verplicht
        </error-warning>
        <error-warning v-if="this.invalidPassword">
          {{ this.invalidPassword }}
        </error-warning>
      </form-group>

        <button
            v-if="isEditMode"
            class="button order medium fullwidth"
            :disabled="isSubmitting"
        >
            <span>Save</span>

            <div :class="{'button-spinner': true, 'hidden': !isSubmitting}"></div>
        </button>

        <button
            v-if="isEditMode"
            class="button medium fullwidth"
            type="button"
            @click="cancel"
        >
            Cancel
        </button>

        <div class="spacingMedium"></div>

        <div v-if="!isEditMode" class="edit">
            <a :href="href" @click.prevent="toggleEditMode">
                Change address
            </a>
        </div>
    </form>
</template>

<script>
    import { email } from 'vuelidate/dist/validators.min.js';

    import {requiredString} from '../../utils/prop-types';
    import profileService from '../../services/profile';
    import ErrorWarning from '../ErrorWarning.vue';
    import FormGroup from './ContactFormGroup.vue';

    const {updateContactInfo, abortContactInfoUpdating} = profileService;

    function required(value) {
        return !this.isSubmitted || value.trim();
    }

    export default {
        props: {
            action: requiredString,
            name: requiredString,
            phone: requiredString,
            email: requiredString,
            href: requiredString,
            password: requiredString,
        },
        components: {
            'error-warning': ErrorWarning,
            'form-group': FormGroup,
        },
        data() {
            return {
                isEditMode: false,
                isSubmitting: false,
                isSubmitted: false,
                contacts: {
                    name: this.name,
                    phone: this.phone,
                    email: this.email,
                    password: '',
                },
                invalidPassword: '',
                invalidEmail: '',
                defaultContacts: null,
                request: null,
                isEmptyPassword: false,
            }
        },
        methods: {
            isEmailChanged() {
                return this.$v.contacts.email.$model !== this.email;
            },
            toggleEditMode(evt) {
                this.isEditMode = !this.isEditMode;
            },
            submit() {
                const {action, method} = this.$refs.form;

                this.isSubmitted = true;

                if (this.isEmailChanged() && !this.contacts.password) {
                    this.isEmptyPassword = true;

                    return;
                }
                this.isEmptyPassword = false;


                if (!this.$v.$invalid) {
                    this.isSubmitting = true;

                    updateContactInfo(action, method, this.contacts)
                        .then((res) => {
                            this.isSubmitted = false;
                            if (!res.ok && res.status === 400) {
                                return res.json().then((data) => {
                                    if (data && data.email && data.email.length) {
                                        this.invalidEmail = data.email[0];
                                    }

                                    if (data && data.password && data.password.length) {
                                      this.invalidPassword = data.password[0];
                                    }
                                });
                            }

                            this.updateDefaultUser();
                            this.toggleEditMode();
                            res.json().then((data) => {
                                if (data.redirect) {
                                    window.location.href = data.redirectTo;
                                }
                            });
                        })
                        .catch((err) => {
                            if (err.status === 404) {
                                this.isSubmitted = false;

                                this.updateDefaultUser();
                                this.toggleEditMode();

                                return false;
                            }
                        })
                        .finally(() => {
                            this.isSubmitting = false;
                        });
                }
            },
            cancel() {
                this.isSubmitted = false;
                this.contacts = {...this.defaultContacts};
                this.invalidPassword = '';
                this.invalidEmail = '';
                this.contacts.password = '';

                this.toggleEditMode();
                abortContactInfoUpdating();
            },
            updateDefaultUser() {
                this.defaultContacts = {...this.contacts};
                this.invalidPassword = '';
                this.invalidEmail = '';
                this.contacts.password = '';
            }
        },
        created() {
            this.updateDefaultUser();
        },
        validations: {
            contacts: {
                name: {required},
                phone: {required},
                email: {required, email},
            },
        },
    }
</script>
